export enum TooltipColumnWidth {
  full = "full",
  half = "half",
}
